import React, { useState, useEffect } from 'react';
import {
  Breadcrumb,
  Button,
  Container,
  Divider,
  Input,
  InputGroup,
  Panel,
  SelectPicker,
  Stack,
  Table
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';
const { Column, HeaderCell, Cell } = Table;

const PriceManage = () => {
  const ip = globalIP;
  const [aliasdata, setAliasdata] = useState([]);
  const [aliasload, setAliasload] = useState(false);
  useEffect(() => {
    fetchDataalias();
  }, []);
  const fetchDataalias = async () => {
    if (aliasload) {
      return;
    }
    setAliasload(true);
    try {
      const response = await fetch(`${ip}/api/fetchs-aliascd`);
      const json = await response.json();
      const processedData = json.map(item => ({
        label: item.ProductId,
        value: item.ProductId,
      }));
      setAliasdata(processedData);
      setAliasload(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchDatac();

  }, []);
  const fetchDatac = async () => {

    if (isLoadingc) {
      return;
    }
    setIsLoadingc(true);
    try {
      const response = await fetch(`${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map((item) => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode,
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
      setIsLoadingc(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    fetchData2();
  }, []);
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const response = await fetch(`${ip}/api/mstproducttypes?&pagination[page]=1`);
      const json = await response.json();

      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/mstproducttypes?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map((item) => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode,
        }));
        allData.push(...processedData);
      }
      setProductypedata(allData);
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchDatapron();

  }, []);
  const fetchDatapron = async () => {
    if (isLoadingpron) {
      return;
    }
    setIsLoadingpron(true);
    try {
      const response = await fetch(`${ip}/api/products-name`);
      const json = await response.json();
      const uniqueKeywords = new Set(); // Use a Set to keep track of unique keywords
      json.forEach((item) => {
        if (item.ProductName && !uniqueKeywords.has(item.ProductName)) {
          uniqueKeywords.add(item.ProductName);
        }
      });
      const processedData = Array.from(uniqueKeywords).map((keyword) => ({
        label: keyword,
        value: keyword,
      }));
      setProdNamedata(processedData);
      setIsLoadingpron(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);


  const fetchData = async () => {

    if (isLoading) {
      return;
    }

    setIsLoading(true);
    const categoryFilterString = `filters[CategoryCode][$eq]=${selectedCategory}`
    const protypeFilterString = `filters[ProductTypeCode][$eq]=${selectedProductType}`




    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias.map(alias => `filters[ProductId][$eq]=${alias}`).join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron.map(pron => `filters[ProductName][$eq]=${pron}`).join('&');
      pronFilter = `&${pronFilterString}`;
    }
    const response = await fetch(`${ip}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${currentPage}&${categoryFilterString}&${protypeFilterString}${aliasFilter}${pronFilter}`);
    const json = await response.json();
    // Additional data processing if needed...
    if (currentPage === 1) {
      setData123(json.data);
    } else {
      setData123(prevData => [...prevData, ...json.data]);
    }
    setMeta123(json.meta);
    setIsLoading(false);

  };

  const handleCategoryChange = (value) => {
    setCurrentPage(1); // Reset currentPage when category changes
    setSelectedCategory(value);
    // console.log(value)
  };
  const handleProductTypeChange = (value) => {
    setCurrentPage(1); // Reset page when color changes
    setSelectedProductType(value);
    // console.log(value);
  };
  const handleAliasChange = (value) => {
    setCurrentPage(1); // Reset page when color changes
    setSelectedAlias(value);
  };
  const handleProNameChange = (value) => {
    setCurrentPage(1); // Reset page when color changes
    setSelectedPron(value);
  };

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Fair Master Create</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>
                    Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item active>Create</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5} alignItems='flex-end'>
              <Stack direction='column' alignItems='flex-start' >
                <label>Alias Code</label>
                <SelectPicker style={{ width: 160 }} data={aliasdata} value={selectedAlias} onChange={handleAliasChange} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>Product Name</label>
                <SelectPicker style={{ width: 160 }} data={proNamedata} value={selectedpron} onChange={handleProNameChange} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>Category</label>
                <SelectPicker style={{ width: 160 }} data={categorydata} value={selectedCategory} onChange={handleCategoryChange} />
              </Stack>
              <Stack direction='column' alignItems='flex-start' >
                <label>Product Type</label>
                <SelectPicker style={{ width: 160 }} data={productypedata} value={selectedProductType} onChange={handleProductTypeChange} />
              </Stack>
              <Button appearance='primary' color='cyan' onClick={fetchData}>Search</Button>
            </Stack>
          </Stack>
          <Stack direction='column' alignItems='flex-end' spacing={30} style={{ marginBottom: '-27px' }}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
                <Input placeholder="Search" />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>

            </Stack>

          </Stack>
        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
            <Table height={420} data={data123}
              rowHeight={60}
              rowKey="id"
              bordered
              cellBordered
            >
              <Column width={80} align='center'>
                <HeaderCell><b>S. NO</b></HeaderCell>
                <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
              </Column>
              <Column width={160} align='center'>
                <HeaderCell><b>Product Name</b></HeaderCell>
                <Cell dataKey={'attributes.ProductName'} />
              </Column>
              <Column width={160} align='center'>
                <HeaderCell><b>Alias Code</b></HeaderCell>
                <Cell dataKey={'attributes.ProductId'} />
              </Column>
              <Column width={160} align='center'>
                <HeaderCell><b>Session</b></HeaderCell>
                <Cell dataKey={'attributes.sessionFair'} />
              </Column>
              <Column width={160} align='center'>
                <HeaderCell><b>Fair Days</b></HeaderCell>
                <Cell dataKey={'attributes.fairdays'} />
              </Column>
              <Column width={160} align='center'>
                <HeaderCell><b>Location</b></HeaderCell>
                <Cell dataKey={'attributes.location'} />
              </Column>



            </Table>

          </Panel>
        </div>

        <Stack className="copyright" justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
          <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERPDaddy Software Solution.</a></p>
        </Stack>
      </Container>
    </>
  )
}
export default PriceManage;